import Collapsible from "app/components/Collapsible/Collapsible";
import { HelpAndLearningSections } from "app/helpers/helpAndLearningHelper";
import { ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const HelpAndLearningContent = () => {
  const [welcomeActive, setWelcomeActive] = useState(true);
  const [getStartedActive, setGetStartedActive] = useState(true);
  const [rulesAndRegulationsActive, setRulesAndRegulationsActive] =
    useState(true);
  const [contactsAndSupportActive, setContactsAndSupportActive] =
    useState(true);
  const [faqsActive, setFaqsActive] = useState(true);
  const [aboutUsActive, setAboutUsActive] = useState(true);
  const [responsibleGamingActive, setResponsibleGamingActive] = useState(true);
  const [termsAndConditionsActive, setTermsAndConditionsActive] =
    useState(true);
  const [selfExclusionActive, setSelfExclusionActive] = useState(true);

  const onToggleCollapsible = type => {
    switch (type) {
      case HelpAndLearningSections.WELCOME:
        setWelcomeActive(!welcomeActive);
        break;
      case HelpAndLearningSections.GET_STARTED:
        setGetStartedActive(!getStartedActive);
        break;
      case HelpAndLearningSections.RULES_AND_REGULATIONS:
        setRulesAndRegulationsActive(!rulesAndRegulationsActive);
        break;
      case HelpAndLearningSections.CONTACTS_AND_SUPPORT:
        setContactsAndSupportActive(!contactsAndSupportActive);
        break;
      case HelpAndLearningSections.FAQS:
        setFaqsActive(!faqsActive);
        break;
      case HelpAndLearningSections.ABOUT_US:
        setAboutUsActive(!aboutUsActive);
        break;
      case HelpAndLearningSections.RESPONSIBLE_GAMING:
        setResponsibleGamingActive(!responsibleGamingActive);
        break;
      case HelpAndLearningSections.TERMS_AND_CONDITIONS:
        setTermsAndConditionsActive(!termsAndConditionsActive);
        break;
      case HelpAndLearningSections.SELF_EXCLUSION:
        setSelfExclusionActive(!selfExclusionActive);
        break;
      default:
        break;
    }
  };

  return (
    <div className="help-and-learning__content">
      <div className="help-and-learning__content__info">
        <Collapsible
          status={"open"}
          onToggle={() => onToggleCollapsible(HelpAndLearningSections.WELCOME)}
          header={
            <div className="collapsible-header">
              <FormattedMessage tagName="span" id="helpandlearning-welcome" />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningWelcomeHelpAndLearning
                    : ROUTES.helpAndLearningWelcomeHelpAndLearning
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage tagName="span" id="account-welcome" />
              </Link>
            </div>
          }
          isActive={welcomeActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.GET_STARTED)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage
                tagName="span"
                id="helpandlearning-gettingstarted"
              />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningGettingStartedFundingYourAccount
                    : ROUTES.helpAndLearningGettingStartedFundingYourAccount
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-gettingstarted-fundingyouraccount"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningGettingStartedPlacingABet
                    : ROUTES.helpAndLearningGettingStartedPlacingABet
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="account-minimum-deposit-requirement"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningGettingStartedOurOdds
                    : ROUTES.helpAndLearningGettingStartedOurOdds
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-gettingstarted-ourodds"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningGettingStartedQuickLinks
                    : ROUTES.helpAndLearningGettingStartedQuickLinks
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-gettingstarted-quicklinks"
                />
              </Link>
            </div>
          }
          isActive={getStartedActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.RULES_AND_REGULATIONS)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage
                tagName="span"
                id="helpandlearning-rulesandregulations"
              />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningRulesAndRegulationsSportsRules
                    : ROUTES.helpAndLearningRulesAndRegulationsSportsRules
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-rulesandregulations-sportsrules"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningRulesAndRegulationsMarketRules
                    : ROUTES.helpAndLearningRulesAndRegulationsMarketRules
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-rulesandregulations-marketrules"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningRulesAndRegulationsCodeOfConduct
                    : ROUTES.helpAndLearningRulesAndRegulationsCodeOfConduct
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-rulesandregulations-codeofconduct"
                />
              </Link>
            </div>
          }
          isActive={rulesAndRegulationsActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.CONTACTS_AND_SUPPORT)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage
                tagName="span"
                id="helpandlearning-contactsandsupport"
              />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningContactAndSupportContactUs
                    : ROUTES.helpAndLearningContactAndSupportContactUs
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-contactandsupport-contactus"
                />
              </Link>
            </div>
          }
          isActive={contactsAndSupportActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() => onToggleCollapsible(HelpAndLearningSections.FAQS)}
          header={
            <div className="collapsible-header">
              <FormattedMessage tagName="span" id="helpandlearning-faqs" />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningFaqsMyAccount
                    : ROUTES.helpAndLearningFaqsMyAccount
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-faqs-myaccount"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningFaqsFunding
                    : ROUTES.helpAndLearningFaqsFunding
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-faqs-funding"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningFaqsBetting
                    : ROUTES.helpAndLearningFaqsBetting
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-faqs-betting"
                />
              </Link>
            </div>
          }
          isActive={faqsActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() => onToggleCollapsible(HelpAndLearningSections.ABOUT_US)}
          header={
            <div className="collapsible-header">
              <FormattedMessage tagName="span" id="helpandlearning-aboutus" />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningAboutUsLicenceInformation
                    : ROUTES.helpAndLearningAboutUsLicenceInformation
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-aboutus-licenceinformation"
                />
              </Link>
            </div>
          }
          isActive={aboutUsActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.RESPONSIBLE_GAMING)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage
                tagName="span"
                id="helpandlearning-responsiblegaming"
              />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningResponsibleGaming
                    : ROUTES.helpAndLearningResponsibleGaming
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-responsiblegaming"
                />
              </Link>
            </div>
          }
          isActive={responsibleGamingActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.SELF_EXCLUSION)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage tagName="span" id="settings-self-exclusion" />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningSelfExclusion
                    : ROUTES.helpAndLearningSelfExclusion
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage tagName="span" id="settings-self-exclusion" />
              </Link>
            </div>
          }
          isActive={selfExclusionActive}
          withArrows
        />
        <Collapsible
          status={"open"}
          onToggle={() =>
            onToggleCollapsible(HelpAndLearningSections.TERMS_AND_CONDITIONS)
          }
          header={
            <div className="collapsible-header">
              <FormattedMessage
                tagName="span"
                id="helpandlearning-termsandconditions"
              />
            </div>
          }
          content={
            <div className="collapsible-content">
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningTermsAndConditions
                    : ROUTES.helpAndLearningTermsAndConditions
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-termsandconditions"
                />
              </Link>
              <Link
                to={`${
                  SessionHelper.isAsianRouteAndSessionView()
                    ? ROUTES.asianHelpAndLearningTermsAndConditionsPrivacyPolicy
                    : ROUTES.helpAndLearningTermsAndConditionsPrivacyPolicy
                }`}
                className="helpandlearning__link"
              >
                <FormattedMessage
                  tagName="span"
                  id="helpandlearning-termsandconditions-privacypolicy"
                />
              </Link>
            </div>
          }
          isActive={termsAndConditionsActive}
          withArrows
        />
      </div>
    </div>
  );
};

export default HelpAndLearningContent;
